/**
 * Vertrag fuer Karten-Provider (siehe Konzept "Provider-Abstraktion: OSM -> optional Google Maps").
 * Filter-/Such-/Listenlogik in chip-map.js kennt NUR dieses Interface, nie eine konkrete
 * Kartenbibliothek direkt - ein spaeterer Wechsel auf Google Maps bedeutet: neue Klasse
 * schreiben, die dieselben Methoden implementiert, chip-map.js bleibt unveraendert.
 */
export class MapProvider {
    /**
     * @param {HTMLElement} container
     * @param {{tileUrl: string, attribution: string, centerLat: number, centerLng: number, zoom: number, cluster?: boolean}} options
     *   cluster: wenn true, werden Marker zu Clustern gruppiert (Uebersichtskarte bei vielen
     *   Standorten) statt einzeln auf der Karte zu liegen (Detailkarte: ein Marker, kein Clustering).
     */
    init(container, options) {
        throw new Error('MapProvider.init() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * @param {{uid: number, lat: number, lng: number, name: string, iconUrl: string, color: string, popupHtml: string}} location
     * @returns {*} Provider-spezifisches Marker-Objekt (wird von chip-map.js nur an removeMarker/panTo zurueckgereicht)
     */
    addMarker(location) {
        throw new Error('MapProvider.addMarker() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * @param {*} marker
     */
    removeMarker(marker) {
        throw new Error('MapProvider.removeMarker() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * Fuegt einen zuvor per addMarker() erzeugten (und ggf. per removeMarker() wieder entfernten)
     * Marker erneut ein - fuer Filterlogik in chip-map.js, die Marker rein-/rausfiltert statt sie
     * neu zu erzeugen. Wichtig bei aktiviertem Clustering (siehe options.cluster in init()): dort
     * genuegt CSS-display:none NICHT, weil die Cluster-Zahlen aus der tatsaechlichen
     * Layer-Zugehoerigkeit berechnet werden, nicht aus der CSS-Sichtbarkeit einzelner Marker.
     * @param {*} marker
     */
    showMarker(marker) {
        throw new Error('MapProvider.showMarker() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * Zoomt/zentriert die Karte so, dass alle aktuell sichtbaren Marker im Ausschnitt liegen.
     */
    fitToMarkers() {
        throw new Error('MapProvider.fitToMarkers() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * @param {*} marker
     */
    openPopup(marker) {
        throw new Error('MapProvider.openPopup() muss von einer konkreten Implementierung ueberschrieben werden.');
    }

    /**
     * Zeichnet einen statischen Kontur-Overlay (z. B. Landesgrenze) ohne Marker-Charakter.
     * @param {string} url GeoJSON-Datei
     * @param {{color: string, weight?: number, fillOpacity?: number}} style
     * @returns {Promise<*>} Provider-spezifischer Layer (nur zum spaeteren Entfernen relevant)
     */
    addGeoJsonOverlay(url, style) {
        throw new Error('MapProvider.addGeoJsonOverlay() muss von einer konkreten Implementierung ueberschrieben werden.');
    }
}
